import React, { useState, useEffect } from "react";
import _ from "lodash";
import AspectRatio from "@mui/joy/AspectRatio";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Input from "@mui/joy/Input";
import IconButton from "@mui/joy/IconButton";
import Textarea from "@mui/joy/Textarea";
import Stack from "@mui/joy/Stack";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import Typography from "@mui/joy/Typography";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Link from "@mui/joy/Link";
import Card from "@mui/joy/Card";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Sheet from "@mui/joy/Sheet";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import LinearProgress from "@mui/joy/LinearProgress";
import CircularProgress from "@mui/joy/CircularProgress";
import PricingCard from "../../components/PricingCard";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CardContent from "@mui/joy/CardContent";

import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import AccessTimeFilledRoundedIcon from "@mui/icons-material/AccessTimeFilledRounded";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { auth, storage, functions } from "../../utils/FireStore";
import { signOut } from "firebase/auth";
import { getCompanyById, updateCompanyById } from "../../utils/api/company";
import { setCompanyData } from "../../utils/companySlice";

import * as globalSlice from "../../utils/globalSlice";
import { useDispatch, useSelector } from "react-redux";


// import DropZone from "./DropZone";
// import FileUpload from "./FileUpload";
// import CountrySelector from "./CountrySelector";
// import EditorToolbar from "./EditorToolbar";

export default function CompanyPage() {
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company);
  const companyInfo = {
    companyAddress: company["companyAddress"] || "",
    companyName: company["companyName"] || "",
    companyPhone: company["companyPhone"] || "",
    companyWebsite: company["companyWebsite"] || "",
    companyEmail: company["companyEmail"] || "",
    companyLogo: company["companyLogo"] || "",
  };

  const [newCompanyInfo, setNewCompanyInfo] = useState(companyInfo);
  const [openNewLogoModal, setOpenNewLogoModal] = useState(false);
  const [image, setImage] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [companySubscription, setCompanySubscription] = useState({});
  const [loadingCheckout, setLoadingCheckout] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCompanyInfo({ ...newCompanyInfo, [name]: value });
  };



  const [preview, setPreview] = useState(null);
  const [progress, setProgress] = useState(0);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
      handleUpload(file);
    }
    // setOpenNewLogoModal(false);
  };

  const handleUpdateCompanyInfo = async () => {
    const formattedCompanyInfo = { ...newCompanyInfo };
    if (formattedCompanyInfo.companyWebsite) {
      function formatWebsite(url) {
        return /^(https?:\/\/)/.test(url) ? url : `https://${url}`;
      }

      const formattedWebsite = formatWebsite(newCompanyInfo.companyWebsite);
      formattedCompanyInfo.companyWebsite = formattedWebsite;
    }
    updateCompanyById(company.id, formattedCompanyInfo)
      .then((res) => {
        dispatch(setCompanyData(formattedCompanyInfo));
        dispatch(
          globalSlice.updateFields({
            snackbarText: "Company info updated",
            snackbarOpen: true,
            snackbarColor: "success",
          })
        );
      })
      .catch((err) => alert("Error updating company info: ", err));
  };

  const handleUpload = (image) => {
    if (image) {
      const storageRef = ref(storage, `images/${image.name}`);
      const uploadTask = uploadBytesResumable(storageRef, image);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Progress function
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
        },
        (error) => {
          // Error function
          console.error("Upload failed", error);
        },
        () => {
          // Complete function
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            // setUrl(downloadURL);
            setNewCompanyInfo({ ...newCompanyInfo, companyLogo: downloadURL });
            console.log("File available at", downloadURL);
            setOpenNewLogoModal(false);
            setProgress(0);
          });
        }
      );
    }
  };

  const companyInfoIsEqual = () => {
    return _.isEqual(companyInfo, newCompanyInfo);
  };



  return (
    <>
      <Modal
        aria-labelledby="upload logo"
        aria-describedby="upload new logo icon"
        open={openNewLogoModal}
        onClose={() => {
          setOpenNewLogoModal(false);
        }}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{ maxWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            Upload Logo
          </Typography>
          {progress === 0 && (
            <input type="file" accept="image/*" onChange={handleFileChange} />
          )}
          {progress > 0 && <LinearProgress determinate value={progress} />}
        </Sheet>
      </Modal>
      <Box sx={{ flex: 1, width: "100%" }}>
        <Box
          sx={{
            position: "sticky",
            top: { sm: -100, md: -110 },
            bgcolor: "background.body",
            zIndex: 9995,
          }}
        ></Box>
        <Stack
          spacing={4}
          sx={{
            display: "flex",
            maxWidth: "800px",
            mx: "auto",
            px: { xs: 2, md: 6 },
            py: { xs: 2, md: 3 },
          }}
        >
          <Card>
            <Box sx={{ mb: 1 }}>
              <Typography level="title-md">Company info</Typography>
              <Typography level="body-sm">
                Customize how your company information will apper to the public.
              </Typography>
            </Box>
            <Divider />
            <Stack
              direction="row"
              spacing={3}
              sx={{ display: { xs: "none", md: "flex" }, my: 1 }}
            >
              <Stack direction="column" spacing={1}>
                <AspectRatio
                  ratio="1"
                  maxHeight={200}
                  sx={{ flex: 1, minWidth: 120, borderRadius: "100%" }}
                >
                  <img
                    src={preview || newCompanyInfo.companyLogo}
                    loading="lazy"
                    alt=""
                  />
                </AspectRatio>
                <IconButton
                  onClick={() => setOpenNewLogoModal(true)}
                  aria-label="upload new picture"
                  size="sm"
                  variant="outlined"
                  color="neutral"
                  sx={{
                    bgcolor: "background.body",
                    position: "absolute",
                    zIndex: 2,
                    borderRadius: "50%",
                    left: 100,
                    top: 170,
                    boxShadow: "sm",
                  }}
                >
                  <EditRoundedIcon />
                </IconButton>
              </Stack>
              <Stack spacing={2} sx={{ flexGrow: 1 }}>
                <Stack
                  spacing={1}
                  sx={{
                    display: { sm: "flex-row", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <FormControl>
                    <FormLabel>Company Name</FormLabel>
                    <Input
                      onChange={handleInputChange}
                      value={newCompanyInfo.companyName}
                      name="companyName"
                      size="sm"
                      placeholder="Company Name"
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Phone</FormLabel>
                    <Input
                      onChange={handleInputChange}
                      value={newCompanyInfo.companyPhone}
                      name="companyPhone"
                      size="sm"
                      placeholder="Company Phone"
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Email</FormLabel>
                    <Input
                      onChange={handleInputChange}
                      value={newCompanyInfo.companyEmail}
                      name="companyEmail"
                      size="sm"
                      placeholder="Company Email"
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Address</FormLabel>
                    <Input
                      onChange={handleInputChange}
                      value={newCompanyInfo.companyAddress}
                      name="companyAddress"
                      size="sm"
                      placeholder="Company Address"
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Website</FormLabel>
                    <Input
                      onChange={handleInputChange}
                      value={newCompanyInfo.companyWebsite}
                      name="companyWebsite"
                      size="sm"
                      placeholder="Company Website"
                    />
                  </FormControl>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="column"
              spacing={2}
              sx={{ display: { xs: "flex", md: "none" }, my: 1 }}
            >
              <Stack direction="row" spacing={2}>
                <Stack direction="column" spacing={1}>
                  <AspectRatio
                    ratio="1"
                    maxHeight={108}
                    sx={{ flex: 1, minWidth: 108, borderRadius: "100%" }}
                  >
                    <img
                      src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=286"
                      srcSet="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=286&dpr=2 2x"
                      loading="lazy"
                      alt=""
                    />
                  </AspectRatio>
                  <IconButton
                    aria-label="upload new picture"
                    size="sm"
                    variant="outlined"
                    color="neutral"
                    sx={{
                      bgcolor: "background.body",
                      position: "absolute",
                      zIndex: 2,
                      borderRadius: "50%",
                      left: 85,
                      top: 180,
                      boxShadow: "sm",
                    }}
                  >
                    <EditRoundedIcon />
                  </IconButton>
                </Stack>
                <Stack spacing={1} sx={{ flexGrow: 1 }}>
                  <FormControl
                    sx={{
                      display: {
                        sm: "flex-column",
                        md: "flex-row",
                      },
                      gap: 2,
                    }}
                  >
                    <FormLabel>Name</FormLabel>
                    <Input size="sm" placeholder="First name" />
                  </FormControl>
                </Stack>
                <FormControl
                  sx={{
                    display: {
                      sm: "flex-column",
                      md: "flex-row",
                    },
                    gap: 2,
                  }}
                >
                  <FormLabel>Last name</FormLabel>
                  <Input size="sm" placeholder="Last name" />
                </FormControl>
              </Stack>
              <FormControl>
                <FormLabel>Role</FormLabel>
                <Input size="sm" defaultValue="UI Developer" />
              </FormControl>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>Email</FormLabel>
                <Input
                  size="sm"
                  type="email"
                  startDecorator={<EmailRoundedIcon />}
                  placeholder="email"
                  defaultValue="siriwatk@test.com"
                  sx={{ flexGrow: 1 }}
                />
              </FormControl>
              <div>{/* <CountrySelector /> */}</div>
              <div>
                <FormControl sx={{ display: { sm: "contents" } }}>
                  <FormLabel>Timezone</FormLabel>
                  <Select
                    size="sm"
                    startDecorator={<AccessTimeFilledRoundedIcon />}
                    defaultValue="1"
                  >
                    <Option value="1">
                      Indochina Time (Bangkok){" "}
                      <Typography textColor="text.tertiary" ml={0.5}>
                        — GMT+07:00
                      </Typography>
                    </Option>
                    <Option value="2">
                      Indochina Time (Ho Chi Minh City){" "}
                      <Typography textColor="text.tertiary" ml={0.5}>
                        — GMT+07:00
                      </Typography>
                    </Option>
                  </Select>
                </FormControl>
              </div>
            </Stack>
            <CardOverflow
              sx={{ borderTop: "1px solid", borderColor: "divider" }}
            >
              <CardActions sx={{ alignSelf: "flex-end", pt: 2 }}>
                <Button
                  onClick={() => {
                    setPreview(null);
                    setNewCompanyInfo(companyInfo);
                  }}
                  size="sm"
                  variant="outlined"
                  color="neutral"
                >
                  Cancel
                </Button>
                <Button
                  disabled={companyInfoIsEqual()}
                  size="sm"
                  variant="solid"
                  onClick={handleUpdateCompanyInfo}
                >
                  Save
                </Button>
              </CardActions>
            </CardOverflow>

          </Card>

          {/* <Button onClick={signOutHandler}>Sign Out</Button> */}
        </Stack>
      </Box>
    </>
  );
}
